import { render, staticRenderFns } from "./Shareholders-Profile.vue?vue&type=template&id=781fa8ba"
import script from "./Shareholders-Profile.vue?vue&type=script&lang=js"
export * from "./Shareholders-Profile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports